
import { path } from "ramda";
import yotpoWidgetMixin from "~/mixins/yotpoWidgetMixin";

export default {
  mixins: [yotpoWidgetMixin],
  props: {
    selectedVariant: { type: Object, default: () => {} },
    image: { type: Object, default: () => {} },
    productId: { type: String, required: true },
  },

  computed: {
    imgSrc() {
      return path(["src"], this.image);
    },
  },
};
